import * as zod from 'zod';

export const DisableGripperVariables = zod.object({
  succeeded: zod.boolean(),
});

export type DisableGripperVariables = zod.infer<typeof DisableGripperVariables>;
